// TAKEOVER theme configurations
// All themes use CSS variable tokens that auto-switch via .light/.dark class on <html>
const glassTokens = {
  background: 'bg-surface-0',
  surface: 'bg-surface-1',
  text: 'text-text-primary',
  textSecondary: 'text-text-secondary',
  border: 'border-glass-border',
  hover: 'hover:bg-glass-bg-hover',
  input: 'bg-glass-bg',
  inputBg: 'bg-glass-bg',
  inputText: 'text-text-primary',
  divider: 'border-glass-border',
  tableBorder: 'border-glass-border',
  tableHeader: 'bg-surface-2',
  tableHover: 'hover:bg-glass-bg-hover',
  card: 'glass-card',
};

export const themes = {
    light: {
      ...glassTokens,
      primary: '#E4CA00',
      secondary: '#737373',
      success: '#16A34A',
      error: '#DC2626',
      warning: '#B45309',
      priorityHigh: '#DC2626',
      priorityMedium: '#B45309',
      priorityLow: '#737373',
    },
    dark: {
      ...glassTokens,
      primary: '#E4CA00',
      secondary: '#9CA3AF',
      success: '#22C55E',
      error: '#EF4444',
      warning: '#D4A017',
      priorityHigh: '#EF4444',
      priorityMedium: '#D4A017',
      priorityLow: '#6B6B6B',
    },
    alexModeLight: {
      ...glassTokens,
      primary: '#0077BB',
      secondary: '#737373',
      success: '#007766',
      error: '#AA2200',
      warning: '#CC5500',
      priorityHigh: '#AA2200',
      priorityMedium: '#CC5500',
      priorityLow: '#007766',
    },
    alexModeDark: {
      ...glassTokens,
      primary: '#0077BB',
      secondary: '#9CA3AF',
      success: '#009988',
      error: '#CC3311',
      warning: '#EE7733',
      priorityHigh: '#CC3311',
      priorityMedium: '#EE7733',
      priorityLow: '#009988',
    }
};
